"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.17.1
 */
'use client';

const CUSTOM_OBJECT_VALUE = {};
const CUSTOM_OBJECT_VALUE_LABEL = "Object With Custom Fields";
const CUSTOM_ARRAY_VALUE = [];
const CUSTOM_ARRAY_VALUE_LABEL = "List With Custom Items";
function isCustomFieldValue(value) {
  return [
    JSON.stringify(CUSTOM_OBJECT_VALUE),
    JSON.stringify(CUSTOM_ARRAY_VALUE)
  ].includes(JSON.stringify(value));
}

export { CUSTOM_ARRAY_VALUE, CUSTOM_ARRAY_VALUE_LABEL, CUSTOM_OBJECT_VALUE, CUSTOM_OBJECT_VALUE_LABEL, isCustomFieldValue };
